import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=400d3f9a&scoped=true&"
import script from "./sitemap.vue?vue&type=script&lang=ts&"
export * from "./sitemap.vue?vue&type=script&lang=ts&"
import style0 from "./sitemap.vue?vue&type=style&index=0&id=400d3f9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d3f9a",
  null
  
)

/* custom blocks */
import block0 from "./sitemap.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
